import React, { useState, useEffect } from "react";
import {
    Typography,
    Divider,
    Paper,
    Button,
    IconButton,
    LinearProgress,
    Chip,
    Box,
} from "@mui/material";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import HeaderDashboard from "../../components/HeaderDashboard";
import { useUser } from "../../../contexts/UserContext";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from "react-router-dom";
import { FormatDate } from "../../../utils/FormatDate";
import { FormatToBrl } from "../../../utils/FormatToBrl";
import { MascaraTelefone } from "../../../utils/MascaraTelefone";
import ModalNotificacao from "./ModalNotificacao";
import axios from "axios";
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import HomeIcon from '@mui/icons-material/Home';
import { Breadcrumbs, Link } from "@mui/material";
import ModalCancelarAssinatura from "./ModalCancelarAssinatura";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import AutorenewIcon from "@mui/icons-material/Autorenew";
// import ArrowForwardAltIcon from "@mui/icons-material/ArrowForwardAlt";

const Assinatura = () => {
    const { user } = useUser();
    const navigate = useNavigate();
    const [userActive, setUserActive] = useState(true);
    const [openModalNotificacao, setOpenModalNotificacao] = useState(false);
    const [notificacoes, setNotificacoes] = useState([]);
    const [openModalCancelarAssinatura, setOpenModalCancelarAssinatura] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    console.log(user)
    useEffect(() => {
        const hasFaturasVencidas = user?.faturas?.vencidas?.length > 0;

        if (hasFaturasVencidas) {
            setUserActive(false);
        } else {
            setUserActive(true);
        }
    }, [user]);

    useEffect(() => {
        const getNotify = async () => {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/buscarNotificacoes`, { email: localStorage.getItem("email") }, {
                headers: {
                    Authorization: `${localStorage.getItem("token")}`
                }
            });

            if (response.data.status === 200) {
                setNotificacoes(response.data.notificacoes)
            }
        }

        getNotify();
    }, [])

    // preciso saber a porcentagem do ciclo atual, para isso preciso da data da proxima cobrança e da data da ultima cobrança, com isso consigo calcular a porcentagem do ciclo atual

    const calcularPorcentagemCiclo = () => {
        if (!user?.assinatura?.proximaCobranca) {
            return 0;
        }

        const proximaCobranca = new Date(user.assinatura.proximaCobranca);

        const ultimaCobranca = user?.assinatura?.ultimaCobranca
            ? new Date(user.assinatura.ultimaCobranca)
            : new Date(proximaCobranca.getTime() - (30 * 24 * 60 * 60 * 1000));

        const hoje = new Date();

        const totalMs = proximaCobranca.getTime() - ultimaCobranca.getTime();
        const passadosMs = hoje.getTime() - ultimaCobranca.getTime();

        const porcentagem = Math.min(100, Math.max(0, (passadosMs / totalMs) * 100));
        return Number(porcentagem.toFixed(1));
    };

    const SectionBox = ({ title, children }) => (
        <Box sx={{ mt: 2 }}>
            {title && (
                <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                    {title}
                </Typography>
            )}
            {children}
            <Divider sx={{ mt: 2 }} />
        </Box>
    );

    const InfoRow = ({ label, value, bold }) => (
        <Typography variant="body2" sx={{ mt: 0.5 }}>
            {label && <b>{label} </b>}
            {bold ? <b>{value}</b> : value}
        </Typography>
    );

    function InfoCard({ icon, label, value }) {
        return (
            <Box
                sx={{
                    bgcolor: "#f5f6f8",
                    borderRadius: "14px",
                    p: 1,
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    border: "1px solid #ececec",
                }}
            >
                <Box
                    sx={{
                        width: window.innerWidth > 600 ? 32 : 24,
                        height: 32,
                        borderRadius: "10px",
                        bgcolor: "#dff8e9",
                        color: "#00d26a",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    {icon}
                </Box>

                <Box>
                    <Typography
                        sx={{
                            fontSize: 12,
                            fontWeight: 700,
                            color: "#555",
                        }}
                    >
                        {label}
                    </Typography>

                    <Typography
                        sx={{
                            fontSize: 18,
                            fontWeight: 600,
                        }}
                    >
                        {value}
                    </Typography>
                </Box>
            </Box>
        );
    }


    return (
        <>
            <HeaderDashboard userActive={userActive} setOpenModalNotificacao={setOpenModalNotificacao} notificacoes={notificacoes.length} />
            <div style={{ padding: "30px", background: "#f4f6f8", minHeight: "100vh", marginTop: "64px" }}>
                <div style={{ width: "100%", height: "fit-content", padding: "10px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "20px", marginBottom: "20px" }}>
                        <div style={{ width: "80%" }}>
                            <Breadcrumbs aria-label="breadcrumb">
                                <Link
                                    underline="hover"
                                    sx={{ display: 'flex', alignItems: 'center', cursor: "pointer" }}
                                    color="inherit"
                                    onClick={() => navigate("../dashboard")}
                                >
                                    <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                    Dashboard
                                </Link>
                                <Typography
                                    sx={{ color: 'text.primary', display: 'flex', alignItems: 'center' }}
                                >
                                    <AssignmentTurnedInIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                    Assinaturas & Cobranças
                                </Typography>
                            </Breadcrumbs>
                        </div>
                    </div>
                </div>
                <Paper
                    elevation={3}
                    sx={{
                        p: 4,
                        borderRadius: "20px",
                        bgcolor: "#fff",
                        width: window.innerWidth > 600 ? "80%" : "95%",
                        margin: "0 auto",
                    }}
                >
                    <Typography
                        variant="h4"
                        fontWeight="700"
                        mb={1}
                    >
                        Assinatura e Cobrança
                    </Typography>

                    <Typography
                        variant="body1"
                        color="text.secondary"
                        sx={{ maxWidth: "700px" }}
                    >
                        Aqui você pode gerenciar sua assinatura e cobranças.
                        Se tiver faturas pendentes, regularize sua situação para
                        continuar usufruindo dos nossos serviços.
                    </Typography>

                    <Divider sx={{ my: 4 }} />

                    <Box
                        sx={{
                            display: "flex",
                            gap: 4,
                            flexWrap: "wrap",
                        }}
                    >
                        {/* COLUNA ESQUERDA */}
                        <Box
                            sx={{
                                flex: "1 1 400px",
                                display: "flex",
                                flexDirection: "column",
                                gap: 2,
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: 12,
                                    fontWeight: 700,
                                    letterSpacing: 2,
                                    color: "#555",
                                }}
                            >
                                INFORMAÇÕES DO USUÁRIO
                            </Typography>

                            <InfoCard
                                icon={<PersonOutlineIcon />}
                                label="TITULAR"
                                value={user?.usuario?.Nome || "..."}
                            />

                            <InfoCard
                                icon={<EmailOutlinedIcon />}
                                label="EMAIL"
                                value={user?.usuario?.Email || "..."}
                            />

                            <InfoCard
                                icon={<PhoneOutlinedIcon />}
                                label="TELEFONE"
                                value={user?.usuario?.Telefone ? MascaraTelefone(user.usuario.Telefone) : "..."}
                            />
                        </Box>

                        {/* COLUNA DIREITA */}
                        <Box
                            sx={{
                                flex: "1 1 400px",
                                display: "flex",
                                flexDirection: "column",
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: 12,
                                    fontWeight: 700,
                                    letterSpacing: 2,
                                    color: "#555",
                                    mb: 2,
                                }}
                            >
                                MÉTODO DE PAGAMENTO
                            </Typography>

                            <Box
                                sx={{
                                    bgcolor: "#262b31",
                                    color: "#fff",
                                    borderRadius: "18px",
                                    p: 3,
                                    minHeight: 130,
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    overflow: "hidden",
                                    position: "relative",
                                }}
                            >
                                <Box>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1.5,
                                            mb: 1,
                                        }}
                                    >
                                        <PaymentsOutlinedIcon
                                            sx={{
                                                color: "#00ff84",
                                                fontSize: 32,
                                            }}
                                        />

                                        <Box>
                                            <Typography
                                                fontSize={window.innerWidth > 600 ? 20 : 16}
                                                fontWeight={700}
                                            >
                                                {user?.assinatura?.metodoPagamento ? user?.assinatura?.metodoPagamento === "BOLETO" ? "Boleto Bancário" : "Cartão de Crédito" : "..."}
                                            </Typography>

                                            <Typography
                                                color="#bdbdbd"
                                                fontSize={14}
                                            >
                                                Gerado mensalmente no dia 10
                                            </Typography>
                                        </Box>
                                    </Box>

                                    <Typography
                                        sx={{
                                            fontWeight: 700,
                                            mt: 4,
                                            fontSize: 12,
                                        }}
                                    >
                                        PRÓXIMO VENCIMENTO
                                    </Typography>
                                </Box>

                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "flex-end",
                                        justifyContent: "space-between",
                                        height: "100%",
                                    }}
                                >
                                    <ReceiptLongOutlinedIcon
                                        sx={{
                                            fontSize: window.innerWidth > 600 ? 80 : 60,
                                            color: "rgba(255,255,255,.12)",
                                        }}
                                    />

                                    <Typography
                                        sx={{
                                            color: "#00ff84",
                                            fontWeight: 700,
                                            fontSize: 12,
                                        }}
                                    >
                                        {user?.assinatura?.proximaCobranca ? FormatDate(user.assinatura.proximaCobranca) : "..."}
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Paper>

                <Box
                    sx={{
                        display: "flex",
                        gap: 3,
                        flexWrap: "wrap",
                        width: "80%",
                        margin: "30px auto 0 auto",
                    }}
                >
                    {/* CARD PRINCIPAL */}
                    <Paper
                        elevation={3}
                        sx={{
                            flex: "1 1 700px",
                            p: 4,
                            borderRadius: "20px",
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "flex-start",
                                flexWrap: "wrap",
                                gap: 2,
                            }}
                        >
                            <Box>
                                <Typography
                                    variant="h4"
                                    fontWeight={700}
                                >
                                    Detalhes do Plano
                                </Typography>

                                <Typography
                                    color="text.secondary"
                                    mt={0.5}
                                >
                                    Sua jornada digital começa com o pé direito!
                                </Typography>
                            </Box>

                            <Chip
                                label={user?.plano?.nome || "..."}
                                sx={{
                                    bgcolor: "#2EF07C",
                                    color: "#000",
                                    fontWeight: 700,
                                    letterSpacing: 1,
                                    px: 2,
                                }}
                            />
                        </Box>

                        {/* Próxima cobrança */}
                        <Box
                            sx={{
                                mt: 4,
                                p: 2,
                                borderRadius: "16px",
                                bgcolor: "#F5F6F8",
                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    mb: 3,
                                    flexWrap: "wrap",
                                }}
                            >
                                <Typography color="text.secondary">
                                    Próxima cobrança:
                                </Typography>

                                <Typography
                                    fontWeight={700}
                                    fontSize={20}
                                >
                                    {user?.assinatura?.proximaCobranca ? FormatDate(user.assinatura.proximaCobranca) : "..."}
                                </Typography>
                            </Box>

                            <LinearProgress
                                variant="determinate"
                                value={calcularPorcentagemCiclo()}
                                sx={{
                                    height: 7,
                                    borderRadius: 10,
                                    bgcolor: "#ddd",
                                    "& .MuiLinearProgress-bar": {
                                        bgcolor: "#2EF07C",
                                        borderRadius: 10,
                                    },
                                }}
                            />

                            <Typography
                                variant="body2"
                                color="text.secondary"
                                mt={2}
                            >
                                ⏺ {calcularPorcentagemCiclo()}% do ciclo atual concluído
                            </Typography>
                        </Box>

                        {/* Botões */}
                        <Box
                            sx={{
                                mt: 4,
                                display: "flex",
                                gap: 2,
                                flexWrap: "wrap",
                            }}
                        >
                            <Button
                                variant="outlined"
                                endIcon={<ArrowRightAltIcon />}
                                sx={{
                                    minWidth: 220,
                                    height: 50,
                                    borderRadius: "14px",
                                    fontWeight: 700,
                                    letterSpacing: 1,
                                }}
                                onClick={() => navigate("/dashboard/faturas/pagas")}
                            >
                                DETALHES DE COBRANÇA
                            </Button>

                            <Button
                                variant="contained"
                                endIcon={<AutorenewIcon />}
                                sx={{
                                    minWidth: 220,
                                    height: 50,
                                    borderRadius: "14px",
                                    fontWeight: 700,
                                    bgcolor: "#2EF07C",
                                    color: "#000",
                                    boxShadow: "none",
                                    "&:hover": {
                                        bgcolor: "#24d96d",
                                    },
                                }}
                                onClick={() => navigate("/dashboard/mudarPlano")}
                            >
                                MUDAR MEU PLANO
                            </Button>
                        </Box>
                    </Paper>

                    {/* RESUMO MENSAL */}
                    <Paper
                        elevation={3}
                        sx={{
                            width: "fit-content",
                            minHeight: 360,
                            borderRadius: "20px",
                            p: 3,
                            background:
                                "linear-gradient(135deg,#24282d 0%,#1f2529 100%)",
                            color: "#fff",
                        }}
                    >
                        <Typography
                            sx={{
                                color: "#8f9397",
                                fontSize: 12,
                                fontWeight: 700,
                                letterSpacing: 2,
                            }}
                        >
                            RESUMO MENSAL
                        </Typography>

                        <Typography
                            sx={{
                                mt: 3,
                                color: "#2EF07C",
                                fontWeight: 800,
                                fontSize: 56,
                                lineHeight: 1,
                            }}
                        >
                            {user?.asaas?.value ? FormatToBrl(user?.asaas?.value) : "..."}
                        </Typography>

                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                mt: 2,
                            }}
                        >
                            <Chip
                                label="ATIVO"
                                size="small"
                                sx={{
                                    bgcolor: "#163d29",
                                    color: "#2EF07C",
                                    fontWeight: 700,
                                }}
                            />

                            <Typography color="#9ca3af">
                                Ciclo Mensal
                            </Typography>
                        </Box>

                        {/* Ilustração */}
                        <Box
                            sx={{
                                mt: 5,
                                height: 140,
                                borderRadius: "16px",
                                bgcolor: "rgba(0,0,0,.15)",
                                backdropFilter: "blur(5px)",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <Typography
                                sx={{
                                    color: "rgba(46,240,124,.3)",
                                    fontSize: 90,
                                    fontWeight: 900,
                                }}
                            >
                                $
                            </Typography>
                        </Box>
                    </Paper>

                    {/* CANCELAMENTO */}
                    <Paper
                        elevation={2}
                        sx={{
                            width: "100%",
                            p: 4,
                            mt: 1,
                            borderRadius: "20px",
                            borderLeft: "4px solid #E53935",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            flexWrap: "wrap",
                            gap: 3,
                        }}
                    >
                        <Box>
                            <Typography
                                sx={{
                                    color: "#E53935",
                                    fontWeight: 700,
                                    fontSize: 28,
                                }}
                            >
                                Encerrar Assinatura
                            </Typography>

                            <Typography color="text.secondary">
                                Ao cancelar, você perderá acesso às ferramentas de
                                automação contábil premium.
                            </Typography>
                        </Box>

                        <Button
                            variant="outlined"
                            startIcon={<CancelOutlinedIcon />}
                            color="error"
                            sx={{
                                minWidth: 240,
                                height: 50,
                                borderRadius: "14px",
                                fontWeight: 700,
                                letterSpacing: 1,
                            }}
                            onClick={() => setOpenModalCancelarAssinatura(true)}
                        >
                            CANCELAR ASSINATURA
                        </Button>
                    </Paper>
                </Box>
            </div>
            <ModalCancelarAssinatura
                openModalCancelarAssinatura={openModalCancelarAssinatura}
                setOpenModalCancelarAssinatura={setOpenModalCancelarAssinatura}
            />
        </>
    )
}

export default Assinatura;